(function () {
    'use strict';

    angular
        .module('app.core')
        .config(config);

    config.$inject = ['$provide', 'gettextCatalogProvider'];
    function config($provide, gettextCatalogProvider) {
        $provide.decorator('gettextCatalog', gettextCatalogDecorator);

        gettextCatalogDecorator.$inject = ['$delegate', '$q', '$interpolate'];
        function gettextCatalogDecorator($delegate, $q, $interpolate) {
            var originalSetStrings = $delegate.setStrings,
                languageLocationPattern = gettextCatalogProvider.languageLocationPattern,
                languageLocation = $interpolate(languageLocationPattern || '');

            $delegate.loadLanguage = loadLanguage;
            $delegate.setStrings = setStrings;
            return $delegate;

            ///////////////////////////////////
            function loadLanguage(lang) {
                var isLoaded = !!(this.strings[lang] || lang === this.baseLanguage),
                    locale = lang && lang.replace('-', '_'),
                    url = languageLocation({ locale: locale });

                return isLoaded ? $q.resolve() : url ? this.loadRemote.call(this, url) : $q.reject();
            }

            function setStrings(language, strings) {
                language = language && language.replace('_', '-').toLowerCase();
                originalSetStrings.call(this, language, strings);
            }
        }
    }
})();